// PixelProvider.jsx - Initialize Facebook, Snapchat, and Reddit Pixels
// File: src/components/PixelProvider.jsx

import React, { useEffect } from 'react';
import { initFacebookPixel, initSnapchatPixel, initRedditPixel } from '../utils/pixels';

const PixelProvider = ({ children }) => {
  useEffect(() => {
    // Initialize all pixels when the app loads
    initFacebookPixel();
    initSnapchatPixel();
    initRedditPixel();
    
    console.log('Facebook, Snapchat, and Reddit Pixels initialized - ready to track events');
  }, []);

  return <>{children}</>;
};

export default PixelProvider;